import { render, staticRenderFns } from "./SummaryBox.vue?vue&type=template&id=46d26e88&scoped=true&"
import script from "./SummaryBox.vue?vue&type=script&lang=js&"
export * from "./SummaryBox.vue?vue&type=script&lang=js&"
import style0 from "./SummaryBox.vue?vue&type=style&index=0&id=46d26e88&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d26e88",
  null
  
)

export default component.exports